import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './login';
import Main from './main';
import Dashboard from './main/dashboard';
import Users from './main/users';
import Stores from './main/stores';
import Products from './main/products';
import Orders from './main/orders';
import VirtualOrders from './main/virtual-orders';
import Chats from './main/chats';

function RequireAuth({ children }) {
  return localStorage.getItem('token') ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Main />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="stores" element={<Stores />} />
        <Route path="products" element={<Products />} />
        <Route path="orders" element={<Orders />} />
        <Route path="virtual-orders" element={<VirtualOrders />} />
        <Route path="chats" element={<Chats />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
